import {
	INTERACTION_TYPE,
	SCOPE_TYPE,
} from 'app/interfaces/actiontracker.interface';
import { ActionTrackerService } from 'app/services/actiontracker.service';

import { ITrackerScopes } from '../interfaces/experiment.interface';

export class AlephbetAdapter {
	constructor(
		public ATService: ActionTrackerService,
		public trackerScopes: ITrackerScopes
	) {}

	public experiment_start(experiment, variant) {
		this.ATService.eventTracker(
			SCOPE_TYPE.ABExperiment,
			this.trackerScopes.subscope,
			this.trackerScopes.item,
			INTERACTION_TYPE.Start,
			{
				experiment: experiment.name,
				variant,
			}
		);
	}
	public goal_complete(experiment, variant) {
		this.ATService.eventTracker(
			SCOPE_TYPE.ABExperiment,
			this.trackerScopes.subscope,
			this.trackerScopes.item,
			INTERACTION_TYPE.GoalComplete,
			{
				experiment: experiment.name,
				variant,
				goalName: '',
			}
		);
	}
}
